/**************************************************
 * Nombre:       Home_Tiempo_Limitado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import Tarjeta_Producto_Tiempo_Limitado from "../../Tarjetas/Tarjeta_Producto_Tiempo_Limitado";
import {NavigateBefore,NavigateNext} from "@mui/icons-material";
import {theme} from "../../../Tema";
import {useRef} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Tiempo_Limitado = () => {
    const {sCell} = useResponsive()
    const refe = useRef()

    const atras = () => {
        if (refe.current) {
            refe.current.splide.go('<'); // Mueve al slide anterior
        }
    };

    const adelante = () => {
        if (refe.current) {
            refe.current.splide.go('>'); // Mueve al slide siguiente
        }
    };

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#EEEFE9'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2}}
            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>

                    <Grid  container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Splide
                            ref={refe}
                            aria-label="My Favorite Images"
                            options={{
                                autoplay: true,
                                speed: 3000,
                                rewind: true,
                                arrows: false,
                                pagination: true,
                                width: '100%',
                                drag: false,
                                interval: 10000,
                                noDrag: true,
                                type: 'fade',


                            }}
                        >

                            {items.map((item, index) => {
                                return (
                                    <SplideSlide key={`qe${index}`}>
                                        <Tarjeta_Producto_Tiempo_Limitado/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>
                    </Grid>

                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                        sx={{mt: -10}}
                    >

                        <IconButton
                            onClick={() => atras()}
                            sx={{
                            backgroundColor: theme.palette.secondary.main,
                        }}>
                            <NavigateBefore sx={{fill: theme.palette.primary.main}} />
                        </IconButton>

                        <IconButton
                            onClick={() => adelante()}
                            sx={{
                                backgroundColor: theme.palette.secondary.main
                            }}
                        >
                            <NavigateNext sx={{fill: theme.palette.primary.main}}/>
                        </IconButton>

                    </Grid>

                </Grid>






            </Grid>

        </Grid>
    )

}
export default Home_Tiempo_Limitado

const items = [1, 2, 3]